module.exports = __webpack_public_path__ + "img/telegram.919a6e22.svg";